import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { buildQueryParams } from '@app/shared/http.query-params';
import { SpringPageResponseData } from '@app/shared/searchable.model';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { Observable } from 'rxjs';
import { SalaryScale, SalaryScaleSearch } from './salary-scale.model';

export interface ISalaryScalesService {
  list(salaryScaleSearch: SalaryScaleSearch): Observable<SpringPageResponseData<SalaryScale>>;
  create(salaryScale: SalaryScale): Observable<SalaryScale>;
  update(salaryScale: SalaryScale): Observable<SalaryScale>;
}

@Injectable({
  providedIn: 'root',
})
export class SalaryScalesService implements ISalaryScalesService {
  private dialog = inject(MatDialog);
  private httpClient = inject(HttpClient);

  private url = `${inject(RUNTIME_CONFIG).apiUrl}/contracts/salary-scales`;

  findMostRecentBefore(
    jobTypeId: number,
    startDate: string | moment.Moment,
  ): Observable<SalaryScale> {
    const atDate = typeof startDate === 'string' ? startDate : startDate.format('YYYY-MM-DD');
    return this.httpClient.get<SalaryScale>(`${this.url}/applicable`, {
      params: buildQueryParams({ jobTypeId, atDate }),
    });
  }

  list(salaryScaleSearch: SalaryScaleSearch): Observable<SpringPageResponseData<SalaryScale>> {
    return this.httpClient.get<SpringPageResponseData<SalaryScale>>(this.url, {
      params: buildQueryParams(salaryScaleSearch),
    });
  }

  create(salaryScale: SalaryScale): Observable<SalaryScale> {
    return this.httpClient.post<SalaryScale>(this.url, salaryScale);
  }

  update(salaryScale: SalaryScale): Observable<SalaryScale> {
    return this.httpClient.put<SalaryScale>(`${this.url}/${salaryScale.id}`, salaryScale);
  }

  findBySalaryScaleEntryId(salaryScaleEntryId: number): Observable<SalaryScale> {
    return this.httpClient.get<SalaryScale>(`${this.url}/entries/${salaryScaleEntryId}`);
  }
}
